exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inline-button[data-v-50ad15c4] {\n  display: inline-block;\n}\n", ""]);

// exports
